import { Score, TreatmentType } from "@keita/lanepatrol-sdk";
import { LabelDetection } from "./LabelDetection";
import { ScoreImpact } from "../../coding/models/ScoreImpact";

export interface LocationCoordinates {
  latitude: number;
  longitude: number;
  altitude: number | null;
}

export interface UpdateCraNodeLocation {
  craNodeId: string;
  latitude: number;
  longitude: number;
}

export interface CraNode extends LocationCoordinates {
  id: string;
  craWayId: string;
  name: string;
  index: number;
  distanceFromStart: number;
  distanceToNext: number;
  slope: number;
  dateTime: string;
  photoStatus: NodePhotoStatus;
  photo: {
    fileName: string;
    url: string | any;
    source: PhotoSource;
    panoramic: boolean;
  } | null;
  score: Score | null;
  labels: LabelDetection[] | null;
  treatments: Treatment[] | null;
  scoreImpact: ScoreImpact | null;
}

export interface Treatment {
  type: TreatmentType;
  score: Score;
}

export interface CreateCraNode extends LocationCoordinates {
  craWayId: string;
  name: string;
  index: number;
  dateTime: string;
  photo: {
    image: string;
    source: PhotoSource;
  } | null;
}

export enum PhotoSource {
  Hardware = "Hardware",
  Screen = "Screen",
  HlaSimulation = "HlaSimulation",
}

export enum CraWayUploadProcessStatus {
  IN_PROGRESS = "IN_PROGRESS",
  FAILED = "FAILED",
  DONE = "DONE",
}

export interface CraWayUploadStatus {
  status?: CraWayUploadProcessStatus;
  progress?: number;
}

export enum NodePhotoStatus {
  Raw = "Raw",
  Ready = "Ready",
  Failed = "Failed",
}
